// extracted by mini-css-extract-plugin
export default {"service":"serviceComponent_service__KB05P"};